import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import ArgonBox from "components/ArgonBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { toast } from "react-toastify";
import api from "utils/api";
import BannerForm from "Views/Banner/BannerForm";
import {
  appendBannerFields,
  emptyBannerForm,
  validateBannerForm,
} from "Views/Banner/bannerOptions";

function AddBanner() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(emptyBannerForm);
  const [bannerImage, setBannerImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [loading, setLoading] = useState(false);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Please select a valid image file");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image size should be less than 5MB");
      return;
    }
    setBannerImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const message = validateBannerForm(formData, { requireImage: true, hasImage: Boolean(bannerImage) });
    if (message) {
      toast.error(message);
      return;
    }

    setLoading(true);
    try {
      const data = new FormData();
      appendBannerFields(data, formData);
      data.append("bannerImage", bannerImage);

      const response = await api.post("/banners", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        toast.success(response.data.message || "Banner created successfully");
        navigate("/banner");
      } else {
        toast.error(response.data.message || "Failed to create banner");
      }
    } catch (error) {
      console.error("Error creating banner:", error);
      toast.error(error.response?.data?.message || "Failed to create banner");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Card>
          <ArgonBox p={3}>
            <BannerForm
              heading="Add New Banner"
              submitLabel="Create Banner"
              formData={formData}
              setFormData={setFormData}
              imagePreview={imagePreview}
              imageCaption="Preview"
              onImageChange={handleImageChange}
              onSubmit={handleSubmit}
              onCancel={() => navigate("/banner")}
              loading={loading}
            />
          </ArgonBox>
        </Card>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddBanner;
